import { ax } from "@/core";
import { EditProjectRequestNoteModal } from "@/modals/sales/edit-project-request-note-modal";
import type { ProjectRequestTimelineNoteEntry } from "@msuite/katana";
import {
	Box,
	HStack,
	Menu,
	MenuButton,
	MenuDivider,
	MenuItem,
	MenuList,
	Portal,
	Text,
	UnstyledIconButton,
	useAsyncModal,
	useDisclosure,
	useUIContext,
} from "@msuite/picasso";
import { type FC, Fragment } from "react";
import { IoEllipsisVertical, IoTrash } from "react-icons/io5";
import { TbEdit } from "react-icons/tb";

/** Props Interface */
interface NoteMenuProps {
	projectRequestId: string;
	entry: ProjectRequestTimelineNoteEntry & { id: string };
}

export const NoteMenu: FC<NoteMenuProps> = ({ projectRequestId, entry }) => {
	/** Context */
	const { colors } = useUIContext();

	/** Hooks */
	const asyncModal = useAsyncModal();
	const editProjectRequestNoteModal = useDisclosure();

	/** Functions */
	async function handleOnDelete() {
		try {
			const isConfirmed = await asyncModal({
				headerText: "Notiz löschen",
				bodyText:
					"Möchten Sie diese Notiz wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
				confirmButtonText: "Löschen",
				cancelButtonText: "abbrechen",
			});
			if (!isConfirmed) return;
			await ax.delete(`/v2/project-requests/${projectRequestId}/note/${entry.id}`);
		} catch (error) {
			console.error(error);
		}
	}

	/** Render */
	return (
		<Fragment>
			{editProjectRequestNoteModal.isOpen && (
				<EditProjectRequestNoteModal
					projectRequestId={projectRequestId}
					noteId={entry.id}
					isOpen={editProjectRequestNoteModal.isOpen}
					onClose={editProjectRequestNoteModal.onClose}
				/>
			)}
			<Box
				position="absolute"
				top={0}
				right={0}
				padding={2}
			>
				<Menu placement="bottom-end">
					<MenuButton>
						<UnstyledIconButton
							icon={<IoEllipsisVertical />}
							aria-label="menu"
							size="xs"
							variant="ghost"
						/>
					</MenuButton>
					<Portal>
						<MenuList>
							<MenuItem
								onClick={editProjectRequestNoteModal.onOpen}
								closeOnSelect
							>
								<HStack spacing={2}>
									<Text color={colors.gray}>
										<TbEdit />
									</Text>
									<Text>Notiz bearbeiten</Text>
								</HStack>
							</MenuItem>
							<MenuDivider />
							<MenuItem onClick={handleOnDelete}>
								<HStack spacing={2}>
									<Text color={colors.red}>
										<IoTrash />
									</Text>
									<Text color={colors.red}>Notiz löschen</Text>
								</HStack>
							</MenuItem>
						</MenuList>
					</Portal>
				</Menu>
			</Box>
		</Fragment>
	);
};
